import { LINKS } from 'constants/links';

export const NAVBAR_MENU = [
  { title: 'Career Design Workshop', href: LINKS.careerDesignWorkshop.href },
  { title: 'Free Tools', href: LINKS.careerAdventure.href },
  { title: 'Articles', href: 'https://witgritfit.com/articles/' },
  { title: 'Contact us', href: 'https://witgritfit.com/contact-us/' },
];

export const ABOUT_NAVBAR_OPTIONS = [
  { title: 'Who we are', href: 'https://witgritfit.com/about-us/' },
  { title: 'Our partners', href: 'https://witgritfit.com/our-partners/' },
  {
    title: ' Corporate Social Responsibility',
    href: 'https://avidadventures.org/volunteering/',
  },
];

export const WGF_NAVBAR_OPTIONS = [
  {
    title: 'WIT: A Smart Steer To Success',
    href: 'https://witgritfit.com/career-design/wit/',
  },
  {
    title: 'GRIT: How Character Will Get You There',
    href: 'https://witgritfit.com/career-design/grit/',
  },
  {
    title: ' FIT: Where You Shine Best',
    href: 'https://witgritfit.com/career-design/fit/',
  },
];
